/* eslint-disable max-len */
import store from "@/store";
import { getVariableSyntax } from "@/assets/js/appFunc";
import { defaultFormats } from "./DateFormat/DateFormats";

const dataModelData = {};

store()
    .dispatch("diagrams/getModelForProcessDefinition")
    .then(rsp => {
        dataModelData.lists = store().getters["diagrams/modelForProcessDefinition"]({ withProps: { isList: true } });
        dataModelData.all = rsp.data;
    });

function getFormatedEl(formatted, model, reverseBreadcrumbs, type, modelType) {
    type = type.toLowerCase();
    const defaultLanguage = localStorage.getItem("language");
    let freemarker = formatted;
    if (formatted && !formatted.startsWith("${(")) {
        freemarker = `\${(${formatted})!}`;
    }
    if (type === "string") {
        const newTemplate = "!?replace('\\r\\n','<br>')}";
        freemarker = formatted.replace("!}", newTemplate);
    }
    // eslint-disable-next-line max-len
    return `<span data-freemarker="${freemarker}" data-after="${model}" contenteditable="false" data-type="${type}" data-lang="${defaultLanguage}" data-format="${defaultFormats[
        type
    ] || ""}" class="fr-deletable fr-tribute last-inserted${
        type === "richtext" ? " rich-text-block" : ""
    }"><dfn style="display: inline-block; width: 0px">&nbsp;</dfn><span contenteditable="false" data-before="${reverseBreadcrumbs[1]}" class="${modelType}">${
        reverseBreadcrumbs[0]
    }</span>&nbsp;</span>`;
}

export function addDataTableV2(data, context) {
    const html = [];
    const modelType = data.source === "MOD" ? "DML" : data.source;
    const headerItems = [];
    const bodyItems = [];
    let fieldsKeys = Object.keys(data.fields);
    fieldsKeys = fieldsKeys.filter(el => el !== "_index");
    for (let i = 0; i < fieldsKeys.length; i++) {
        const key = fieldsKeys[i];
        if (data.fields[key].isList) {
            // eslint-disable-next-line no-continue
            continue;
        }
        const pathArray = data.fields[key].key.split(".");
        let relativePath = pathArray.slice(1).join(".");
        const { type } = data.fields[key];
        const prefix = "${(";
        const suffix = getVariableSyntax(data.source, type).variableEnd;
        const isCatalog = store().getters["diagrams/getCatalogByName"](type);
        const reverseBreadcrumbs = [...pathArray].reverse();
        if (isCatalog) {
            reverseBreadcrumbs.unshift("name");
            relativePath += ".name";
        }
        // eslint-disable-next-line no-useless-escape
        const formatted = `${prefix}${relativePath}${suffix.replace(/\"/g, "'")}`;
        const model = `${pathArray[0]}.${relativePath}`;
        const item = `${getFormatedEl(formatted, model, reverseBreadcrumbs, type, modelType)}&nbsp;`;
        const [first = "", ...rest] = key;
        const upperKey = `${first.toUpperCase()}${[...rest].join("")}`; // astral plane
        headerItems.push(`<th style="vertical-align: top; text-align: center;">${upperKey}</th>`);
        bodyItems.push(`<td style="vertical-align: top; text-align: center;">${item}</td>`);
    }
    html.push(
        // eslint-disable-next-line max-len
        `<table style="width: 100%; max-width: 100% !important" class="froala-table fr-collapsed-borders fr-default-borders" data-after="${data.key}"><thead><tr>`
    );
    html.push(headerItems.join(""));
    html.push(`</tr></thead><tbody><tr data-list="${data.model} "data-item="${data.name}">`);
    html.push(bodyItems.join(""));
    html.push("</tr></tbody></table>");
    context.selection.restore();
    let container = context.$(context.selection.element());
    if (!container.hasClass("conditional-block")) {
        container = container.parentsUntil(context.$el, ".conditional-block").first();
    }
    if (container.hasClass("conditional-block")) {
        if (container.hasClass("blkel")) {
            context.html.insert(html.join(""));
        } else {
            context.selection.save();
            container
                .find(".fr-marker")
                .first()
                .replaceWith(html.join(""));
        }
    } else {
        context.html.insert(html.join(""));
    }
    context.events.trigger("contentChanged");
}

export function addDataTable(data, context) {
    const html = [];
    const modelType = data.formatted.slice(0, 1).toLowerCase() === "m" ? "DML" : "VAR";
    const headerItems = [];
    const bodyItems = [];
    let fieldsKeys = Object.keys(data.fields);
    fieldsKeys = fieldsKeys.filter(el => el !== "_index");
    for (let i = 0; i < fieldsKeys.length; i++) {
        const key = fieldsKeys[i];
        if (data.fields[key].isList) {
            // eslint-disable-next-line no-continue
            continue;
        }
        const pathArray = data.fields[key].key.split(".");
        let relativePath = pathArray.slice(1).join(".");
        const { type } = data.fields[key];
        const prefix = "${(";
        const suffix = getVariableSyntax("MOD", type).variableEnd;
        const isCatalog = store().getters["diagrams/getCatalogByName"](type);
        const reverseBreadcrumbs = [...pathArray].reverse();
        if (isCatalog) {
            reverseBreadcrumbs.unshift("name");
            relativePath += ".name";
        }
        // eslint-disable-next-line no-useless-escape
        const formatted = `${prefix}${relativePath}${suffix.replace(/\"/g, "'")}`;
        const model = `${pathArray[0]}.${relativePath}`;
        const item = `${getFormatedEl(formatted, model, reverseBreadcrumbs, type, modelType)}&nbsp;`;
        const [first = "", ...rest] = key;
        const upperKey = `${first.toUpperCase()}${[...rest].join("")}`; // astral plane
        headerItems.push(`<th style="vertical-align: top; text-align: center;">${upperKey}</th>`);
        bodyItems.push(`<td style="vertical-align: top; text-align: center;">${item}</td>`);
    }
    html.push(
        // eslint-disable-next-line max-len
        `<table style="width: 100%; max-width: 100% !important" class="froala-table fr-collapsed-borders fr-default-borders" data-after="${data.key}"><thead><tr>`
    );
    html.push(headerItems.join(""));
    html.push(`</tr></thead><tbody><tr data-list="${data.formatted} "data-item="${data.node.label}">`);
    html.push(bodyItems.join(""));
    html.push("</tr></tbody></table>");
    context.selection.restore();
    let container = context.$(context.selection.element());
    if (!container.hasClass("conditional-block")) {
        container = container.parentsUntil(context.$el, ".conditional-block").first();
    }
    if (container.hasClass("conditional-block")) {
        if (container.hasClass("blkel")) {
            context.html.insert(html.join(""));
        } else {
            context.selection.save();
            container
                .find(".fr-marker")
                .first()
                .replaceWith(html.join(""));
        }
    } else {
        context.html.insert(html.join(""));
    }
    context.events.trigger("contentChanged");
}

export function formatDataModelVar({ model, formatted, type }) {
    const modelType = model.slice(0, 1).toLowerCase() === "m" ? "DML" : "VAR";
    const reverseBreadcrumbs = model
        .slice(2)
        .split(".")
        .reverse();
    return getFormatedEl(formatted, model, reverseBreadcrumbs, type, modelType);
}

export function getDynamicImageEl({ pathArray, formatted, key, type }) {
    const dataBefore = `${pathArray[pathArray.length - 2]}.${pathArray[pathArray.length - 1]}`;
    return `<span data-freemarker="${formatted}" data-after="${key}" contenteditable="false" data-type="${
        type.toLowerCase()}" class="dynamic-image-block last-inserted" data-before="${dataBefore}" data-img-class="fr-fic fr-dii" data-img-style="">&nbsp;</span>`;
}
